import LoginView from "./LoginView";
import {useContext, useState} from "react";
import {APIContext} from "../Globals.tsx";
import {storeInStorage} from "../api/LocalStorage.tsx";

export default function Login({setToken}){

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const {login, getEgo, fetchCoaches} = useContext(APIContext)

    function handleEmailInput(e){
        setEmail(e.target.value);
    }

    function handlePasswordInput(e){
        setPassword(e.target.value);
    }

    async function handleClick(e){
        e.preventDefault();
        //login to weexplan not weex box
        let ego = (await login(email, password));
        let token = ego?.token;
        if(token != null){
            localStorage.setItem("token", token);
            await storeInStorage("box", ego.boxes[0]);
            await localStorage.setItem("backendUrl", ego.boxes[0].backend)
            //get ego of box
            ego = (await getEgo())
            if(ego){
                fetchCoaches().then((coaches)=>{
                    if(!coaches.persons.find((coach)=>coach.id === ego.id)){
                        localStorage.clear();
                        window.location.reload();
                    } else {
                        localStorage.setItem("ego", JSON.stringify(ego));
                        setToken(token);
                    }
                })
            }else{
                localStorage.clear()
            }
        }
    }

    // eigene Funktion für forgot Passwort
    function forgotPassword(){
        console.log(email);
    }

    return (
        <div onKeyUp={(e)=>e.key==='Enter'&&handleClick(e)}>
            <LoginView handleEmailInput={handleEmailInput}
                       handlePasswordInput={handlePasswordInput}
                       handleClick={handleClick}
                       forgotPassword={forgotPassword}
                       email={email}
                       password={password}/>
        </div>
    );
}


